import * as types from '../type/RecommendTeacher.type';
const defaultData = {
	teacherList: []
};

const teachers = (state = defaultData, action) => {
	let copyState = { ...state };
	switch (action.type) {
		case types.GET_RECOMMEND_TEACHER:
			copyState.teacherList = action.res;
			return copyState;
		default:
			return copyState;
	}
};
export default teachers;



// WEBPACK FOOTER //
// ./src/redux/reducer/RecommendTeacher.reducer.js